import React from 'react';
import { useReport, formatReportModuleParams } from '@tencent/dz-report';
export var useReportService = function (_a) {
    var content = _a.content, recommendMode = _a.recommendMode, nerMode = _a.nerMode;
    var report = useReport();
    var cardParams = {
        module_id: content.id,
        module_value: content.name,
        module_type: 'card_hospital',
        module_chinese_type: '医院卡片',
        element_id: content.id,
        element_type: 'card_hospital',
        element_chinese_type: '医院卡片',
        element_content: content.name,
        recommend_mode: recommendMode,
        ner_mode: nerMode,
    };
    var detailParams = {
        module_id: content.id,
        module_value: content.name,
        module_type: 'card_hospital_detail_popup',
        module_chinese_type: '医院卡片_详情弹窗',
        element_id: content.id,
        element_type: 'card_hospital_detail_popup',
        element_chinese_type: '医院卡片_详情弹窗',
        element_content: content.name,
    };
    var cardReportModuleParams = formatReportModuleParams(cardParams);
    React.useEffect(function () {
        report.exposure(cardParams);
    }, []);
    var hospitalModalExposure = function () {
        report.exposure(detailParams);
    };
    var hospitalClick = function () {
        report.click(cardParams);
    };
    return {
        cardReportModuleParams: cardReportModuleParams,
        hospitalModalExposure: hospitalModalExposure,
        hospitalClick: hospitalClick,
    };
};
